import { useSyncExternalStore } from 'react';
import { getLocale, subscribeLocale, type Locale } from './index.js';

/**
 * Joriy tilni React ga bog'laydi. Til modul darajasida yashaydi (`t()` uni
 * to'g'ridan-to'g'ri o'qiydi), shuning uchun holat React dan tashqarida —
 * `useSyncExternalStore` aynan shu holat uchun.
 */
export const useLocale = (): Locale => useSyncExternalStore(subscribeLocale, getLocale, getLocale);
